import { createCoreMethod } from '../../utils/createCoreMethod';
import { findNodeById } from '../../utils/findNodeById';
import { findTextNodes } from '../../utils/findTextNodes';
import { getImageWithoutTextNodes } from '../../utils/getImageWithoutTextNodes';
import { isNodeWithSize } from '../../utils/isNodeWithSize';
import { shallowFind } from '../../utils/shallowFind';

export const getImageWithoutTextForNodeId = createCoreMethod(
  'getImageWithoutTextForNodeId',
  async (nodeId: string): Promise<Uint8Array | null> => {
    let node: BaseNode | null = shallowFind(nodeId);

    if (!node) {
      node = findNodeById(nodeId, figma.currentPage, 99);
    }

    if (!node || !isNodeWithSize(node)) return null;

    const textNodes = findTextNodes(node);

    const res = await getImageWithoutTextNodes(node, textNodes);

    const bytes = res?.take();

    return bytes || null;
  }
);
